import React from 'react';
import classnames from 'classnames';
import styles from './Card.scss';

const addScrollListener = (element) => {
  if (!element) return;

  element.classList.toggle('scroll-observer', true);
  element.intersectionObserver = new IntersectionObserver(
    (entries) =>
      entries.forEach(({ target, isIntersecting }) => {
        target.classList.toggle('isHidden', isIntersecting < 0.5);
      }),
    {
      root: element,
      rootMargin: '0px',
      threshold: 0,
    },
  );

  let frame = false;
  element.addEventListener('scroll', () => {
    if (!frame) {
      frame = window.requestAnimationFrame(() => {
        element.style.setProperty('--offset', `-${element.scrollTop}px`);
        frame = false;
      });
    }
  });
};

const ModalCardBody = ({ children, className, ...props }) => {
  return (
    <section
      {...props}
      className={classnames('modal-card-body', className, styles.flexible)}
      ref={addScrollListener}
    >
      {children}
    </section>
  );
};

export default ModalCardBody;

export const checkVisibility = (element) => {
  if (!element) return;
  let observing = false;
  element.addEventListener('focusin', () => {
    if (observing) {
      return;
    }
    element.closest('.scroll-observer')?.intersectionObserver.observe(element);
    observing = true;
  });
};
